import gql from 'graphql-tag';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const AppointmentEstimateFragmentDoc = gql`
    fragment appointmentEstimate on AppointmentEstimate {
  appointmentId
  estWaitForCheckoutTime
  estCheckoutTime
  estCheckInTime
  estWaitForIntakeTime
  estIntakeTime
  estWaitForDoctorTime
  estInExamTime
  estCheckoutEndTime
  suggestedArrivalTime
  oneHourPrevSuggestedArrivalTime
}
    `;
export const PracticePatientLocationFragmentDoc = gql`
    fragment practicePatientLocation on PracticePatientLocation {
  practicePatientLocationId
  practiceId
  departmentId
  name
  usedForCheckIn
  usedForWaitForIntake
  usedForIntake
  usedForWaitForDoctor
  usedForExam
  usedForWaitForCheckout
  usedForCheckingOut
  defaultOnCheckIn
}
    `;
export const AppointmentOverviewSelfFragmentDoc = gql`
    fragment appointmentOverviewSelf on Appointment {
  appointmentId
  providerId
  scheduleProviderId
  renderingProviderId
  practiceId
  departmentId
  patientId
  appointmentTypeId
  srcType
  status
  appointmentTypeName
  patientAppointmentTypeName
  patientManualCheckIn
  timeScheduled
  timeCreated
  timeUpdated
  timeCheckIn
  timeCheckInStart
  timeCheckInEnd
  timeIntakeEnd
  timeIntakeStart
  timeExamStart
  timeExamEnd
  timeExamEndCompiled
  timeCheckOutStart
  timeCheckOutEnd
  timeCancelled
  timeFirstTexted
  timeFirstTextedSuggestedArrivalTime
  timeLatestTexted
  timeLatestTextedSuggestedArrivalTime
  urgent
  cancelReasonId
  cancelledBy
  timeEncounterCheckedOut
  timeReadyForProvider
  timeReadyForStaff
  pausedAt
  patientManualCheckIn
  roomReady
  duration
  autoPausedAt
  rescheduledAppointmentId
  confirmationStatusRef
  created
  updated
  readyForCheckInBroadcastAt
  roomReadyButtonClickedAt
  timeDoneButtonPressed
  timeDrsLinkSent
  encounterId
  timeChartIntakeStart
  timeChartExamStart
  timeChartExamEnd
  timeIntakeEndDerived
  sourceChartIntakeStart
  sourceChartExamStart
  sourceChartExamEnd
  timeWaitForIntakeStartInferredFromLocation
  timeIntakeStartInferredFromLocation
  timeReadyForProviderInferredFromLocation
  timeExamStartInferredFromLocation
  timeWaitForCheckoutStartInferredFromLocation
  timeCheckOutStartInferredFromLocation
  timeCheckInStartFhirInferred
  timeIntakeStartFhirInferred
  timeIntakeEndFhirInferred
  timeExamStartFhirInferred
  timeExamEndFhirInferred
  timeCheckOutStartFhirInferred
  timeCheckInStartCompiled
  timeIntakeStartCompiled
  timeIntakeEndCompiled
  timeExamStartCompiled
  timeExamEndCompiled
  timeCheckOutStartCompiled
  timeCheckedOutCompiled
  appointmentEstimate {
    ...appointmentEstimate
  }
  practicePatientLocation {
    ...practicePatientLocation
  }
  isDone
  isPaused
  isAutoPaused
  isInLagState
  isNotSeen
  isNotStarted
  isActualEndTimeIndeterminate
  isActualEndTimeDeterminate
  canBePaused
  calculatedAppointmentStatus
  statusString
  timelineIndex
  _timeCheckInStart
  _timeCheckInEnd
  _timeIntakeStart
  _timeIntakeEnd
  _timeExamStart
  _timeExamEnd
  _timeCheckOutStart
  _timeCheckOutEnd
}
    ${AppointmentEstimateFragmentDoc}
${PracticePatientLocationFragmentDoc}`;
export const ConfirmationStatusFragmentDoc = gql`
    fragment confirmationStatus on ConfirmationStatus {
  confirmationStatusId
  name
  isConfirmed
}
    `;
export const AppointmentTextFragmentDoc = gql`
    fragment appointmentText on AppointmentText {
  appointmentTextId
  phoneNumber
  appointmentId
  twilioResponse
  created
  messageBody
}
    `;
export const AppointmentTokenSessionFragmentDoc = gql`
    fragment appointmentTokenSession on AppointmentTokenSession {
  appointmentId
  appointmentToken
  liveUrl
  timePatientSiteFirstVisited
  created
  updated
  expire
}
    `;
export const PhoneNumberFragmentDoc = gql`
    fragment phoneNumber on TtPhoneNumber {
  type
  number
}
    `;
export const AddressFragmentDoc = gql`
    fragment address on TtAddress {
  street1
  street2
  city
  state
  zip
  county
  country
  addressString
}
    `;
export const PatientScheduleProviderSameDayNoShowCountFragmentDoc = gql`
    fragment patientScheduleProviderSameDayNoShowCount on PatientScheduleProviderSameDayNoShowCount {
  practiceId
  patientId
  totalCount
  maxSameDayCancellationDateScheduled
  minSameDayCancellationDateScheduled
  sameDayCancellationCount
  maxNoShowDateScheduled
  minNoShowDateScheduled
  noShowCount
}
    `;
export const PatientOverviewFragmentDoc = gql`
    fragment patientOverview on Patient {
  patientId
  srcType
  firstName
  middleName
  lastName
  dob
  nameInitials
  nameDisplay
  firstNameDisplay
  fullNameDisplay
  ageInYears
  suffix
  preferredName
  sex
  consentToCall
  consentToText
  cannotSmsReason
  canSms
  emailAddresses
  languages
  created
  updated
  phoneNumbers {
    ...phoneNumber
  }
  address {
    ...address
  }
  patientScheduleProviderSameDayNoShowCounts {
    nodes {
      ...patientScheduleProviderSameDayNoShowCount
    }
  }
}
    ${PhoneNumberFragmentDoc}
${AddressFragmentDoc}
${PatientScheduleProviderSameDayNoShowCountFragmentDoc}`;
export const ProviderDepartmentOptionCompiledFragmentDoc = gql`
    fragment providerDepartmentOptionCompiled on ProviderDepartmentOptionsCompiled {
  providerId
  practiceId
  departmentId
  appointmentTypeId
  showCheckInButtonInVwr
  showSuggestedArrivalTimeInVwr
  anchorAutoPauseToSuggestedArrivalTime
  patientSiteShowCallButton
  patientSiteShowIntakeForm
  patientSiteShowLocation
  patientSiteContactTranslationId
  patientSiteDirectionsTranslationId
  patientSiteRemoteDirectionsTranslationId
  appointmentPlaceholderMessageTranslationId
  appointmentScheduledMessageTranslationId
  appointmentReminderMessageTranslationId
  appointmentDelayedMessageTranslationId
  appointmentRoomReadyMessageTranslationId
  patientSiteFaqTranslationId
  patientSiteIntakeFormUrlTranslationId
  patientSiteGettingToLinkATranslationId
  patientSiteGettingToLinkBTranslationId
  patientSiteBeforeLinkATranslationId
  patientSiteBeforeLinkBTranslationId
  patientSiteArrivedLinkATranslationId
  patientSiteArrivedLinkBTranslationId
  patientSiteAboutLinkATranslationId
  patientSiteAboutLinkBTranslationId
  patientSiteAfterLinkATranslationId
  patientSiteAfterLinkBTranslationId
  googlePlaceId
  suggestedArrivalTimeMaxDriftMinutes
  patientSiteDisplayPaymentPortal
  patientSiteDisplayPatientPortal
  appointmentsHideOnStatus
  appointmentsHideOnManager
  appointmentsDisableDelayCalc
  patientSiteDisplayLatestSmsSuggestedArrivalTime
  patientSitePracticeSlugId
  autoPauseAfterMinutes
  forcePauseAfterMinutes
  minMinutesBetweenReminderTexts
  patientSiteAboutVideoLinkTranslationId
  useRenderingProvider
  statsType
  persistCheckInToEhr
  useStatsV2
  useMLDurations
  excludeFromViewsAndQueues
  appointmentsAutoTextingDisabled
  noSmsBeforeMinutesIntoDay
  pollPatientChartsOnWaitForIntakeVitals
  pollPatientChartsOnWaitForIntakeAllergies
  pollPatientChartsOnWaitForIntakeEncounterReasons
  pollPatientChartsOnWaitForIntakeProblems
  pollPatientChartsOnWaitForDoctorHpi
  pollPatientChartsOnWaitForDoctorOrders
  pollPatientChartsOnWaitForDoctorEncounterReasons
  pollPatientChartsOnWaitForDoctorReviewOfSystem
  pollPatientChartsOnExamDiagnosis
  canRollbackStatus
  useBetaOverbookedStackingBehavior
  useStatusInferenceByLocation
  preventSatBeforeDepartmentOpenHour
  patientSiteGettingToTextContentTranslationId
  patientSiteBeforeTextContentTranslationId
  patientSiteArrivedTextContentTranslationId
  patientSiteAboutTextContentTranslationId
  patientSiteAfterTextContentTranslationId
  patientSiteHeaderPracticeFileId
}
    `;
export const AppointmentCycleConfigCompiledFragmentDoc = gql`
    fragment appointmentCycleConfigCompiled on AppointmentCycleConfigCompiled {
  practiceId
  departmentId
  appointmentTypeId
  providerId
  checkIn
  waitForIntake
  intake
  waitForExam
  exam
  waitForCheckout
  waitForCheckOut: waitForCheckout
  checkout
  checkOut: checkout
}
    `;
export const AppointmentTypeProviderStatFragmentDoc = gql`
    fragment appointmentTypeProviderStat on AppointmentTypesProviderStat {
  providerId
  appointmentTypeId
  estimatedDuration
  checkInPredictedDuration
  waitForIntakePredictedDuration
  intakePredictedDuration
  waitForDoctorPredictedDuration
  waitForExamPredictedDuration: waitForDoctorPredictedDuration
  inExamPredictedDuration
  examPredictedDuration: inExamPredictedDuration
  waitForCheckoutPredictedDuration
  waitForCheckOutPredictedDuration: waitForCheckoutPredictedDuration
  checkOutPredictedDuration
}
    `;
export const StatsCompiledFragmentDoc = gql`
    fragment statsCompiled on StatsCompiled {
  intakePredictedDuration
  inExamPredictedDuration
  checkOutPredictedDuration
  checkInPredictedDuration
  waitForIntakePredictedDuration
  waitForDoctorPredictedDuration
  waitForCheckOutPredictedDuration
}
    `;
export const MlPredictedDurationsFragmentDoc = gql`
    fragment mlPredictedDurations on AppointmentPredictedDuration {
  checkInPredictedDuration
  waitForIntakePredictedDuration
  intakePredictedDuration
  waitForDoctorPredictedDuration
  inExamPredictedDuration
  waitForCheckOutPredictedDuration
  checkOutPredictedDuration
}
    `;
export const AppointmentStatesFragmentDoc = gql`
    fragment appointmentStates on AppointmentStateInts {
  checkIn
  waitForIntake
  intake
  waitForExam
  exam
  waitForCheckout
  checkout
}
    `;
export const AppointmentOverviewFragmentDoc = gql`
    fragment appointmentOverview on Appointment {
  ...appointmentOverviewSelf
  nextAppointmentId
  nextAppointment {
    ...appointmentOverviewSelf
    provider {
      providerId
      displayName
      displayNameCompiled
      displayNameOverride
    }
  }
  previousAppointmentId
  previousAppointment {
    ...appointmentOverviewSelf
    provider {
      providerId
      displayName
      displayNameCompiled
      displayNameOverride
    }
  }
  hl7ProviderIdUsed
  confirmationStatus {
    ...confirmationStatus
  }
  appointmentTexts: appointmentTextsByAppointmentIdAndPracticeId(
    orderBy: CREATED_ASC
  ) {
    nodes {
      ...appointmentText
    }
  }
  appointmentTokenSession {
    ...appointmentTokenSession
  }
  patient {
    ...patientOverview
  }
  providerDepartmentOptionCompiled {
    ...providerDepartmentOptionCompiled
  }
  appointmentCycleConfigCompiled {
    ...appointmentCycleConfigCompiled
  }
  appointmentTypeProviderStat {
    ...appointmentTypeProviderStat
  }
  statsCompiled {
    ...statsCompiled
  }
  appointmentPredictedDuration {
    ...mlPredictedDurations
  }
  completedStateDurations {
    ...appointmentStates
  }
}
    ${AppointmentOverviewSelfFragmentDoc}
${ConfirmationStatusFragmentDoc}
${AppointmentTextFragmentDoc}
${AppointmentTokenSessionFragmentDoc}
${PatientOverviewFragmentDoc}
${ProviderDepartmentOptionCompiledFragmentDoc}
${AppointmentCycleConfigCompiledFragmentDoc}
${AppointmentTypeProviderStatFragmentDoc}
${StatsCompiledFragmentDoc}
${MlPredictedDurationsFragmentDoc}
${AppointmentStatesFragmentDoc}`;
export const AdminUpdateAppointmentMutationResultFragmentDoc = gql`
    fragment adminUpdateAppointmentMutationResult on Mutation {
  updateAppointment(
    input: {appointmentId: $appointmentId, practiceId: $practiceId, patch: $patch}
  ) {
    appointment {
      ...appointmentOverview
    }
  }
  queueRecalculateProviderDayAppts(input: {providerId: $providerId}) {
    ids
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const AuthInsightsMutationResultFragmentDoc = gql`
    fragment authInsightsMutationResult on Mutation {
  authInsights {
    jwt
  }
}
    `;
export const AuthTableauMutationResultFragmentDoc = gql`
    fragment authTableauMutationResult on Mutation {
  authTableau(email: $email) {
    jwt
  }
}
    `;
export const ChangeManagerPasswordMutationResultFragmentDoc = gql`
    fragment changeManagerPasswordMutationResult on Mutation {
  changeManagerPassword(input: $input) {
    boolean
  }
}
    `;
export const CreateProviderDepartmentAutoTextPausesMutationResultFragmentDoc = gql`
    fragment createProviderDepartmentAutoTextPausesMutationResult on Mutation {
  createProviderDepartmentAutoTextPauses(
    input: {providerIds: $providerIds, practiceId: $practiceId}
  ) {
    providerDepartmentAutoTextPauses {
      practiceId
      providerId
      pauseOnDate
    }
  }
}
    `;
export const PauseAppointmentMutationResultFragmentDoc = gql`
    fragment pauseAppointmentMutationResult on Mutation {
  updateAppointment(
    input: {appointmentId: $appointmentId, practiceId: $practiceId, patch: {pausedAt: $pausedAt}}
  ) {
    appointment {
      appointmentId
      pausedAt
      canBePaused
      isPaused
      isAutoPaused
    }
  }
  queueRecalculateProviderDayAppts(input: {providerId: $providerId}) {
    ids
  }
}
    `;
export const QueueAppointmentSmsMutationResultFragmentDoc = gql`
    fragment queueAppointmentSmsMutationResult on Mutation {
  queueSendSms(input: $input) {
    ids
  }
}
    `;
export const QueueDemoAppointmentTextMutationResultFragmentDoc = gql`
    fragment queueDemoAppointmentTextMutationResult on Mutation {
  queueDemoAppointmentText(input: $input) {
    ids
  }
}
    `;
export const SetAppointmentDoneMutationResultFragmentDoc = gql`
    fragment setAppointmentDoneMutationResult on Mutation {
  updateAppointment(
    input: {appointmentId: $appointmentId, practiceId: $practiceId, patch: {status: "CHECKED_OUT", timeCheckOutEnd: $timeEnd, pausedAt: null}}
  ) {
    appointment {
      ...appointmentOverview
    }
  }
  queueRecalculateProviderDayAppts(input: {providerId: $providerId}) {
    ids
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const SetAppointmentReadyForCheckInMutationResultFragmentDoc = gql`
    fragment setAppointmentReadyForCheckInMutationResult on Mutation {
  queueReadyForCheckIn(input: $input) {
    ids
  }
  updateAppointment(
    input: {appointmentId: $appointmentId, practiceId: $practiceId, patch: {roomReadyButtonClickedAt: $roomReadyButtonClickedAt}}
  ) {
    appointment {
      appointmentId
      roomReadyButtonClickedAt
    }
  }
}
    `;
export const UnpauseAppointmentMutationResultFragmentDoc = gql`
    fragment unpauseAppointmentMutationResult on Mutation {
  updateAppointment(
    input: {appointmentId: $appointmentId, practiceId: $practiceId, patch: {pausedAt: null}}
  ) {
    appointment {
      appointmentId
      pausedAt
      canBePaused
      isPaused
      isAutoPaused
    }
  }
  queueRecalculateProviderDayAppts(input: {providerId: $providerId}) {
    ids
  }
}
    `;
export const ActorOverviewFragmentDoc = gql`
    fragment actorOverview on Actor {
  actorId
  deletedAt
  timeLastActive
  adminDashboardSettings
  managerDashboardSettings
  managerAppointmentSortDirection
  managerNotifyTimeInReceptionDelays
  managerNotifyTimeInReceptionDelaysMethod
  managerNotifyTimeInReceptionDelaysAfterMinutes
  managerIgnoreTimeInReceptionEarlyCheckIn
  managerNotifyWaitForIntakeDelays
  managerNotifyWaitForIntakeDelaysMethod
  managerNotifyWaitForIntakeDelaysAfterMinutes
  managerNotifyWaitForDoctorDelays
  managerNotifyWaitForDoctorDelaysMethod
  managerNotifyWaitForDoctorDelaysAfterMinutes
  managerDisplayPatientInitialsOnly
  managerStatusSiteAutoSwipeDelaySeconds
  managerGroupAppointmentsByProvider
  managerDisplayArrowStateDurations
  managerNotifyCancellations
  managerDisplayCancellations
  managerDisplayCancellationsWithinHours
  managerDisplayPatientLocation
  managerDisplayIndicatorAfterPracticeNoShowCount
  managerDisplayIndicatorAfterPracticeSameDayCancellationCount
  managerTimeLastRequestedFeedback
  providerGroups {
    name
    providerIds
  }
}
    `;
export const UpdateActorManagerDashboardSettingsMutationResultFragmentDoc = gql`
    fragment updateActorManagerDashboardSettingsMutationResult on Mutation {
  updateActor(
    input: {actorId: $actorId, patch: {managerDashboardSettings: $settings}}
  ) {
    actor {
      ...actorOverview
    }
  }
}
    ${ActorOverviewFragmentDoc}`;
export const UpdateCurrentActorInsightsDashboardSettingsMutationResultFragmentDoc = gql`
    fragment updateCurrentActorInsightsDashboardSettingsMutationResult on Mutation {
  updateCurrentActorInsightsDashboardSettings(input: {settings: $settings}) {
    json
  }
}
    `;
export const ManagerPermissionsFragmentDoc = gql`
    fragment managerPermissions on Manager {
  canAccessCheckoutTable
  canAccessReceptionStatusSite
  canAccessInsights
  canAccessMonthlyReport
  canAccessBilling
  canAccessPatientFlowReport
}
    `;
export const ManagerProviderPermissionFragmentDoc = gql`
    fragment managerProviderPermission on ManagerProviderPermission {
  managerProviderPermissionId
  providerId
  managerId
  practiceId
  departmentId
  created
  updated
}
    `;
export const ManagerOverviewFragmentDoc = gql`
    fragment managerOverview on Manager {
  managerId
  practiceId
  email
  username
  firstName
  lastName
  phoneNumber
  sex
  eulaTimestamp
  nameDisplay
  isPracticeAdmin
  created
  updated
  dateTrialEnd
  tableauManagerId
  ...managerPermissions
  managerProviderPermissions {
    nodes {
      ...managerProviderPermission
    }
  }
  managerActor {
    ...actorOverview
  }
}
    ${ManagerPermissionsFragmentDoc}
${ManagerProviderPermissionFragmentDoc}
${ActorOverviewFragmentDoc}`;
export const ManagerDetailFragmentDoc = gql`
    fragment managerDetail on Manager {
  ...managerOverview
}
    ${ManagerOverviewFragmentDoc}`;
export const UpdateManagerMutationResultFragmentDoc = gql`
    fragment updateManagerMutationResult on Mutation {
  updateManager(input: {managerId: $managerId, patch: $patch}) {
    manager {
      ...managerDetail
    }
  }
}
    ${ManagerDetailFragmentDoc}`;
export const AdminFavoritesQueryResultFragmentDoc = gql`
    fragment adminFavoritesQueryResult on Query {
  adminFavoritePractices(condition: {adminId: $adminId}) {
    nodes {
      adminFavoritePracticeId
      practiceId
    }
  }
  adminFavoriteProviders(condition: {adminId: $adminId}) {
    nodes {
      adminFavoriteProviderId
      providerId
    }
  }
  adminFavoriteDepartments(condition: {adminId: $adminId}) {
    nodes {
      adminFavoriteDepartmentId
      departmentId
    }
  }
  adminFavoriteAppointmentTypes(condition: {adminId: $adminId}) {
    nodes {
      adminFavoriteAppointmentTypeId
      appointmentTypeId
    }
  }
}
    `;
export const LanguageFragmentDoc = gql`
    fragment language on Language {
  languageId
  iso6391Code
  englishName
  enabled
  favorited
}
    `;
export const AllLanguagesQueryResultFragmentDoc = gql`
    fragment allLanguagesQueryResult on Query {
  languages {
    nodes {
      ...language
    }
  }
}
    ${LanguageFragmentDoc}`;
export const AppointmentTypeOverviewFragmentDoc = gql`
    fragment appointmentTypeOverview on AppointmentType {
  appointmentTypeId
  srcType
  practiceId
  name
  nameShort
  nameDisplay
  duration
  estimatedDuration
  created
  updated
  remote
  intakeRequiresExamRoom
  examRequiresExamRoom
  multiDay
  isNewPatientAppointmentType
  appointmentPlaceholderMessageTranslationId
  centsExpectedRevenue
}
    `;
export const ProviderOverviewFragmentDoc = gql`
    fragment providerOverview on Provider {
  providerId
  practiceId
  displayName
  displayNameOverride
  displayNameCompiled
  examRoomCount
  fetchAppointmentsEnabled
  autoTextingEnabledAfter
  doctorCount
  firstName
  lastName
  middleInitial
  specialty
  sex
  username
  npi
  phoneNumber
  created
  updated
  srcType
  excludeFromAppointmentTypeCalculations
  timeOnboarded
  deletedAt
}
    `;
export const DepartmentWorkingHourFragmentDoc = gql`
    fragment departmentWorkingHour on DepartmentWorkingHour {
  departmentWorkingHourId
  practiceId
  departmentId
  overrideDate
  dayOfWeek
  startOfDayMinutes
  endOfDayMinutes
}
    `;
export const GooglePlaceOverviewFragmentDoc = gql`
    fragment googlePlaceOverview on GooglePlace {
  googlePlaceId
  placeId
  name
  formattedAddress
  adrAddress
  types
  url
  utcOffset
  vicinity
  icon
  openingHours {
    periods {
      open {
        day
        time
      }
      close {
        day
        time
      }
    }
  }
  addressComponents {
    longName
    shortName
    types
  }
  geometry {
    location {
      lat
      lng
    }
    viewport {
      northeast {
        lat
        lng
      }
      southwest {
        lat
        lng
      }
    }
  }
}
    `;
export const DepartmentOverviewFragmentDoc = gql`
    fragment departmentOverview on Department {
  departmentId
  practiceId
  name
  publicName
  timezone
  phoneNumber
  created
  updated
  srcType
  departmentWorkingHours(filter: {overrideDate: {isNull: true}}) {
    nodes {
      ...departmentWorkingHour
    }
  }
  googlePlace {
    ...googlePlaceOverview
  }
  address {
    ...address
  }
  srcType
}
    ${DepartmentWorkingHourFragmentDoc}
${GooglePlaceOverviewFragmentDoc}
${AddressFragmentDoc}`;
export const PracticeOverviewFragmentDoc = gql`
    fragment practiceOverview on Practice {
  practiceId
  name
  description
  status
  ownerId
  phoneNumbers {
    ...phoneNumber
  }
  address {
    ...address
  }
  practicesAthena {
    athenaPracticeId
  }
  srcType
  retainEstimationsForMinutes
  created
  timezone
  updated
  defaultDelayedMessageTranslationId
  defaultReminderMessageTranslationId
  defaultPlaceholderMessageTranslationId
  defaultRoomReadyMessageTranslationId
  defaultScheduledMessageTranslationId
  managerDashboardUrl
  patientDashboardUrl
  receptionStatusDashboardUrl
  slug
  includeIntoAppointmentsChangedFetch
  lookForOrphanAppointments
  telehealthEnabled
  appointmentFetchOpenSeconds
  appointmentRefetchByIdOpenSeconds
}
    ${PhoneNumberFragmentDoc}
${AddressFragmentDoc}`;
export const AppointmentDetailFragmentDoc = gql`
    fragment appointmentDetail on Appointment {
  ...appointmentOverview
  appointmentType {
    ...appointmentTypeOverview
  }
  provider {
    ...providerOverview
  }
  department {
    ...departmentOverview
  }
  practice {
    ...practiceOverview
  }
}
    ${AppointmentOverviewFragmentDoc}
${AppointmentTypeOverviewFragmentDoc}
${ProviderOverviewFragmentDoc}
${DepartmentOverviewFragmentDoc}
${PracticeOverviewFragmentDoc}`;
export const AppointmentDetailQueryResultFragmentDoc = gql`
    fragment appointmentDetailQueryResult on Query {
  appointment(appointmentId: $appointmentId, practiceId: $practiceId) {
    ...appointmentDetail
    patient {
      ...patientOverview
    }
    provider {
      ...providerOverview
    }
    appointmentType {
      ...appointmentTypeOverview
    }
    department {
      ...departmentOverview
    }
  }
}
    ${AppointmentDetailFragmentDoc}
${PatientOverviewFragmentDoc}
${ProviderOverviewFragmentDoc}
${AppointmentTypeOverviewFragmentDoc}
${DepartmentOverviewFragmentDoc}`;
export const AppointmentTypeOverviewSetQueryResultFragmentDoc = gql`
    fragment appointmentTypeOverviewSetQueryResult on Query {
  appointmentTypes(
    filter: {practiceId: {equalTo: $practiceId}, appointmentTypeId: {in: $appointmentTypeIds}}
  ) {
    nodes {
      ...appointmentTypeOverview
    }
  }
}
    ${AppointmentTypeOverviewFragmentDoc}`;
export const CurrentActorInsightsDashboardSettingsQueryResultFragmentDoc = gql`
    fragment currentActorInsightsDashboardSettingsQueryResult on Query {
  currentActorInsightsDashboardSettings
}
    `;
export const DepartmentsPracticePatientLocationFragmentDoc = gql`
    fragment departmentsPracticePatientLocation on DepartmentsPracticePatientLocation {
  departmentId
  practicePatientLocationId
}
    `;
export const DepartmentDetailFragmentDoc = gql`
    fragment departmentDetail on Department {
  ...departmentOverview
  departmentsPracticePatientLocations {
    nodes {
      ...departmentsPracticePatientLocation
    }
  }
}
    ${DepartmentOverviewFragmentDoc}
${DepartmentsPracticePatientLocationFragmentDoc}`;
export const DepartmentDetailQueryResultFragmentDoc = gql`
    fragment departmentDetailQueryResult on Query {
  department(departmentId: $departmentId) {
    ...departmentDetail
  }
}
    ${DepartmentDetailFragmentDoc}`;
export const DepartmentOverviewSetQueryResultFragmentDoc = gql`
    fragment departmentOverviewSetQueryResult on Query {
  departments(
    filter: {practiceId: {equalTo: $practiceId}, departmentId: {in: $departmentIds}}
  ) {
    nodes {
      ...departmentOverview
    }
  }
}
    ${DepartmentOverviewFragmentDoc}`;
export const EnabledLanguagesQueryResultFragmentDoc = gql`
    fragment enabledLanguagesQueryResult on Query {
  languages(condition: {enabled: true}) {
    nodes {
      ...language
    }
  }
}
    ${LanguageFragmentDoc}`;
export const TemplateFragmentDoc = gql`
    fragment template on Template {
  templateId
  templateType
  name
  template
  created
  updated
}
    `;
export const GlobalTemplatesQueryResultFragmentDoc = gql`
    fragment globalTemplatesQueryResult on Query {
  templates(condition: {practiceId: null}) {
    nodes {
      ...template
    }
  }
}
    ${TemplateFragmentDoc}`;
export const TranslationFragmentDoc = gql`
    fragment translation on Translation {
  translationId
  overrideTranslationId
  practiceId
  name
  translationType
  created
  updated
}
    `;
export const TranslationContentFragmentDoc = gql`
    fragment translationContent on TranslationContent {
  translationId
  content
  languageId
}
    `;
export const EnglishTranslationContentsFragmentDoc = gql`
    fragment englishTranslationContents on Translation {
  englishTranslationContents: translationContents(
    filter: {languageId: {in: ["eng"]}}
  ) {
    nodes {
      ...translationContent
    }
  }
}
    ${TranslationContentFragmentDoc}`;
export const NonEnglishTranslationContentsFragmentDoc = gql`
    fragment nonEnglishTranslationContents on Translation {
  nonEnglishTranslationContents: translationContents(
    filter: {languageId: {notIn: ["eng"]}}
  ) {
    nodes {
      ...translationContent
    }
  }
}
    ${TranslationContentFragmentDoc}`;
export const TranslationDetailFragmentDoc = gql`
    fragment translationDetail on Translation {
  ...translation
  ...englishTranslationContents
  ...nonEnglishTranslationContents
}
    ${TranslationFragmentDoc}
${EnglishTranslationContentsFragmentDoc}
${NonEnglishTranslationContentsFragmentDoc}`;
export const GlobalTranslationsQueryResultFragmentDoc = gql`
    fragment globalTranslationsQueryResult on Query {
  translations(condition: {practiceId: null}) {
    nodes {
      ...translationDetail
    }
  }
}
    ${TranslationDetailFragmentDoc}`;
export const AdminOverviewFragmentDoc = gql`
    fragment adminOverview on Admin {
  adminId
  email
  phoneNumber
  firstName
  lastName
  created
  updated
  nameDisplay
}
    `;
export const AdminDetailFragmentDoc = gql`
    fragment adminDetail on Admin {
  adminId
  adminActor {
    ...actorOverview
  }
  ...adminOverview
}
    ${ActorOverviewFragmentDoc}
${AdminOverviewFragmentDoc}`;
export const ManagerAdminBaseQueryResultFragmentDoc = gql`
    fragment managerAdminBaseQueryResult on Query {
  admin(adminId: $adminId) {
    ...adminDetail
  }
}
    ${AdminDetailFragmentDoc}`;
export const ManagerAppointmentDayQueryResultFragmentDoc = gql`
    fragment managerAppointmentDayQueryResult on Query {
  appointments: providerDayAppointments(
    practiceId: $practiceId
    providerIds: $providerIds
    dayStart: $dayStart
    dayEnd: $dayEnd
    filterStatuses: $filterStatuses
    managerId: $managerId
  ) {
    nodes {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const TableauLinksFragmentDoc = gql`
    fragment tableauLinks on TableauLinks {
  homeEmbedUrl
  performanceEmbedUrl
  growthEmbedUrl
  deliveryEmbedUrl
  productivityEmbedUrl
  adherenceEmbedUrl
  providerSummaryEmbedUrl
  monthlyReportEmbedUrl
  patientFlowEmbedUrl
}
    `;
export const ServerInfoFragmentDoc = gql`
    fragment serverInfo on ServerInfo {
  name
  uptime
  isProd
  googleMapsApiKey
  hostname
  webhooksServerUrl
}
    `;
export const ManagerBaseQueryResultFragmentDoc = gql`
    fragment managerBaseQueryResult on Query {
  adminId: getSessionAdminId
  managerId: getSessionManagerId
  practiceId: getSessionPracticeId
  tableauLinks {
    ...tableauLinks
  }
  serverInfo {
    ...serverInfo
  }
}
    ${TableauLinksFragmentDoc}
${ServerInfoFragmentDoc}`;
export const HubspotContactFragmentDoc = gql`
    fragment hubspotContact on HubspotContact {
  email
  firstname
  lastname
  phone
  hs_object_id
}
    `;
export const HubspotSubscriptionFragmentDoc = gql`
    fragment hubspotSubscription on HubspotSubscription {
  hs_createdate
  hs_lastmodifieddate
  hs_next_payment_due_date
  hs_recurring_billing_start_date
  hs_object_id
  hs_status
  last_fetched
}
    `;
export const HubspotLineItemFragmentDoc = gql`
    fragment hubspotLineItem on HubspotLineItem {
  name
  description
  quantity
  hs_sku
  hs_object_id
}
    `;
export const PracticeSubscriptionFragmentDoc = gql`
    fragment practiceSubscription on PracticeSubscription {
  practiceSubscriptionId
  practiceId
  created
  updated
  hubspotSubscriptionId
  hubspotSubscriptionData
  hubspotSubscription {
    contacts {
      ...hubspotContact
    }
    subscription {
      ...hubspotSubscription
    }
    lineItems {
      ...hubspotLineItem
    }
  }
}
    ${HubspotContactFragmentDoc}
${HubspotSubscriptionFragmentDoc}
${HubspotLineItemFragmentDoc}`;
export const ManagerBillingInfoQueryResultFragmentDoc = gql`
    fragment managerBillingInfoQueryResult on Query {
  practice(practiceId: $practiceId) {
    practiceId
    practiceSubscriptions {
      nodes {
        ...practiceSubscription
      }
    }
  }
}
    ${PracticeSubscriptionFragmentDoc}`;
export const ManagerCancelledAppointmentDayQueryResultFragmentDoc = gql`
    fragment managerCancelledAppointmentDayQueryResult on Query {
  cancelledAppointments: providerDayCancelledAppointments(
    practiceId: $practiceId
    providerIds: $providerIds
    dayStart: $dayStart
    dayEnd: $dayEnd
    managerId: $managerId
  ) {
    nodes {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const ManagerCancelledAppointmentDayV2QueryResultFragmentDoc = gql`
    fragment managerCancelledAppointmentDayV2QueryResult on Query {
  cancelledAppointments: providerDayCancelledAppointmentsV2(
    practiceId: $practiceId
    providerIds: $providerIds
    dateStart: $dateStart
    dateEnd: $dateEnd
    canceledWithinHours: $canceledWithinHours
    managerId: $managerId
  ) {
    nodes {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const ManagerCancelledAppointmentDayV3QueryResultFragmentDoc = gql`
    fragment managerCancelledAppointmentDayV3QueryResult on Query {
  cancelledAppointments: providerDayCancelledAppointmentsV3(
    practiceId: $practiceId
    providerIds: $providerIds
    dateStart: $dateStart
    dateEnd: $dateEnd
    canceledWithinHours: $canceledWithinHours
    managerId: $managerId
    dateScheduled: $dateScheduled
  ) {
    nodes {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const ManagerManagersHistoryQueryResultFragmentDoc = gql`
    fragment managerManagersHistoryQueryResult on Query {
  manager(managerId: $managerId) {
    managerId
    managerEventDates(orderBy: [TS_START_ASC]) {
      nodes {
        managerId
        startActorId
        startActorName
        endActorId
        endActorName
        eventType
        tsStart
        tsEnd
      }
    }
  }
}
    `;
export const ManagerOverviewQueryResultFragmentDoc = gql`
    fragment managerOverviewQueryResult on Query {
  manager(managerId: $managerId) {
    ...managerOverview
  }
}
    ${ManagerOverviewFragmentDoc}`;
export const ProviderDepartmentAppointmentCountFragmentDoc = gql`
    fragment providerDepartmentAppointmentCount on ProviderDepartmentAppointmentCount {
  providerId
  departmentId
  status
  appointmentCount
  managerAppointmentCount
  practiceId
  dateScheduled
}
    `;
export const ProviderAppointmentsCountFragmentDoc = gql`
    fragment providerAppointmentsCount on Provider {
  providerId
  providerDepartmentAppointmentCounts(
    filter: {dateScheduled: {equalTo: $dayStart}, status: {notIn: ["CANCELED", "LEFT_WITHOUT_BEING_SEEN", "NO_SHOW"]}}
  ) {
    nodes {
      ...providerDepartmentAppointmentCount
    }
  }
}
    ${ProviderDepartmentAppointmentCountFragmentDoc}`;
export const ProviderDetailFragmentDoc = gql`
    fragment providerDetail on Provider {
  ...providerOverview
  ...providerAppointmentsCount
}
    ${ProviderOverviewFragmentDoc}
${ProviderAppointmentsCountFragmentDoc}`;
export const ManagerPracticeBaseQueryResultFragmentDoc = gql`
    fragment managerPracticeBaseQueryResult on Query {
  practice(practiceId: $practiceId) {
    ...practiceOverview
  }
  providers(condition: {practiceId: $practiceId, fetchAppointmentsEnabled: true}) {
    nodes {
      ...providerDetail
      ...providerAppointmentsCount
    }
  }
  disabledProviders: providers(
    condition: {practiceId: $practiceId, fetchAppointmentsEnabled: false}
  ) {
    nodes {
      ...providerDetail
    }
  }
  departments(condition: {practiceId: $practiceId}) {
    nodes {
      ...departmentOverview
    }
  }
}
    ${PracticeOverviewFragmentDoc}
${ProviderDetailFragmentDoc}
${ProviderAppointmentsCountFragmentDoc}
${DepartmentOverviewFragmentDoc}`;
export const ManagerPracticeManagersQueryResultFragmentDoc = gql`
    fragment managerPracticeManagersQueryResult on Query {
  practice(practiceId: $practiceId) {
    practiceId
    managers(orderBy: [LAST_NAME_ASC], condition: {deletedAt: null}) {
      totalCount
      nodes {
        ...managerDetail
        managerProviderPermissions {
          aggregates {
            distinctCount {
              providerId
              departmentId
            }
          }
        }
      }
    }
  }
}
    ${ManagerDetailFragmentDoc}`;
export const ManagerPracticeProviderCountsQueryResultFragmentDoc = gql`
    fragment managerPracticeProviderCountsQueryResult on Query {
  providers(
    filter: {practiceId: {equalTo: $practiceId}, providerId: {in: $providerIds}}
  ) {
    nodes {
      ...providerAppointmentsCount
    }
  }
}
    ${ProviderAppointmentsCountFragmentDoc}`;
export const ManagerProvidersHistoryQueryResultFragmentDoc = gql`
    fragment managerProvidersHistoryQueryResult on Query {
  provider(providerId: $providerId) {
    providerId
    providerEventDates(orderBy: [TS_START_ASC]) {
      nodes {
        providerId
        departmentId
        managerId
        startActorId
        startActorName
        endActorId
        endActorName
        eventType
        tsStart
        tsEnd
      }
    }
  }
}
    `;
export const AppointmentCycleConfigFragmentDoc = gql`
    fragment appointmentCycleConfig on AppointmentCycleConfig {
  appointmentCycleConfigId
  practiceId
  departmentId
  providerId
  appointmentTypeId
  step
  config
  created
  updated
  priority
  estimatedAdjustByMax
  estimatedAdjustmentByPercent
  estimatedMax
  estimatedPercentage
}
    `;
export const PracticeAppointmentCycleConfigsQueryResultFragmentDoc = gql`
    fragment practiceAppointmentCycleConfigsQueryResult on Query {
  appointmentCycleConfigs(
    filter: {or: [{practiceId: {isNull: true}}, {practiceId: {equalTo: $practiceId}}]}
  ) {
    nodes {
      ...appointmentCycleConfig
    }
  }
}
    ${AppointmentCycleConfigFragmentDoc}`;
export const AppointmentCycleDefaultValueFragmentDoc = gql`
    fragment appointmentCycleDefaultValue on AppointmentCycleDefaultValue {
  appointmentCycleDefaultValueId
  practiceId
  departmentId
  providerId
  appointmentTypeId
  step
  minutesDuration
  created
  updated
  priority
}
    `;
export const PracticeAppointmentCycleDefaultValuesQueryResultFragmentDoc = gql`
    fragment practiceAppointmentCycleDefaultValuesQueryResult on Query {
  appointmentCycleDefaultValues(
    filter: {or: [{practiceId: {isNull: true}}, {practiceId: {equalTo: $practiceId}}]}
  ) {
    nodes {
      ...appointmentCycleDefaultValue
    }
  }
}
    ${AppointmentCycleDefaultValueFragmentDoc}`;
export const PracticeOverviewQueryResultFragmentDoc = gql`
    fragment practiceOverviewQueryResult on Query {
  practice(practiceId: $practiceId) {
    ...practiceOverview
  }
}
    ${PracticeOverviewFragmentDoc}`;
export const PracticeProviderAutoTextPausesQueryResultFragmentDoc = gql`
    fragment practiceProviderAutoTextPausesQueryResult on Query {
  providerDepartmentAutoTextPauses(
    condition: {practiceId: $practiceId, pauseOnDate: $pauseOnDate}
  ) {
    nodes {
      providerDepartmentAutoTextPauseId
      providerId
      departmentId
      practiceId
      pauseOnDate
    }
  }
}
    `;
export const PracticeTableauReportFragmentDoc = gql`
    fragment practiceTableauReport on PracticeTableauReport {
  practiceTableauReportId
  practiceId
  title
  slug
  timePublished
  url
  created
  updated
}
    `;
export const PracticeReportsQueryResultFragmentDoc = gql`
    fragment practiceReportsQueryResult on Query {
  practice(practiceId: $practiceId) {
    practiceId
    practiceTableauReports {
      totalCount
      nodes {
        ...practiceTableauReport
      }
    }
  }
}
    ${PracticeTableauReportFragmentDoc}`;
export const PracticeTemplatesQueryResultFragmentDoc = gql`
    fragment practiceTemplatesQueryResult on Query {
  templates(condition: {practiceId: $practiceId}) {
    nodes {
      ...template
    }
  }
}
    ${TemplateFragmentDoc}`;
export const AdminSmsTranslationDetailFragmentDoc = gql`
    fragment adminSmsTranslationDetail on Translation {
  ...translationDetail
}
    ${TranslationDetailFragmentDoc}`;
export const AdminFaqTranslationDetailFragmentDoc = gql`
    fragment adminFaqTranslationDetail on Translation {
  ...translationDetail
}
    ${TranslationDetailFragmentDoc}`;
export const AdminContactTranslationDetailFragmentDoc = gql`
    fragment adminContactTranslationDetail on Translation {
  ...translationDetail
}
    ${TranslationDetailFragmentDoc}`;
export const AdminDirectionsTranslationDetailFragmentDoc = gql`
    fragment adminDirectionsTranslationDetail on Translation {
  ...translationDetail
}
    ${TranslationDetailFragmentDoc}`;
export const GlobalTranslationsFragmentDoc = gql`
    fragment globalTranslations on Query {
  smsTranslations: translations(
    condition: {translationType: "SMS", practiceId: null}
  ) {
    nodes {
      ...adminSmsTranslationDetail
    }
  }
  faqTranslations: translations(
    condition: {translationType: "FAQ", practiceId: null}
  ) {
    nodes {
      ...adminFaqTranslationDetail
    }
  }
  contactTranslations: translations(
    condition: {translationType: "CONTACT", practiceId: null}
  ) {
    nodes {
      ...adminContactTranslationDetail
    }
  }
  directionsTranslations: translations(
    condition: {translationType: "DIRECTIONS", practiceId: null}
  ) {
    nodes {
      ...adminDirectionsTranslationDetail
    }
  }
  linkTranslations: translations(
    condition: {translationType: "LINK", practiceId: null}
  ) {
    nodes {
      ...adminDirectionsTranslationDetail
    }
  }
}
    ${AdminSmsTranslationDetailFragmentDoc}
${AdminFaqTranslationDetailFragmentDoc}
${AdminContactTranslationDetailFragmentDoc}
${AdminDirectionsTranslationDetailFragmentDoc}`;
export const AdminLinkTranslationDetailFragmentDoc = gql`
    fragment adminLinkTranslationDetail on Translation {
  ...translationDetail
}
    ${TranslationDetailFragmentDoc}`;
export const AdminContentTranslationDetailFragmentDoc = gql`
    fragment adminContentTranslationDetail on Translation {
  ...translationDetail
}
    ${TranslationDetailFragmentDoc}`;
export const PracticeTranslationsFragmentDoc = gql`
    fragment practiceTranslations on Practice {
  practiceId
  smsTranslations: translations(condition: {translationType: "SMS"}) {
    nodes {
      ...adminSmsTranslationDetail
    }
  }
  faqTranslations: translations(condition: {translationType: "FAQ"}) {
    nodes {
      ...adminFaqTranslationDetail
    }
  }
  contactTranslations: translations(condition: {translationType: "CONTACT"}) {
    nodes {
      ...adminContactTranslationDetail
    }
  }
  directionsTranslations: translations(condition: {translationType: "DIRECTIONS"}) {
    nodes {
      ...adminDirectionsTranslationDetail
    }
  }
  linkTranslations: translations(condition: {translationType: "LINK"}) {
    nodes {
      ...adminLinkTranslationDetail
    }
  }
  contentTranslations: translations(condition: {translationType: "CONTENT"}) {
    nodes {
      ...adminContentTranslationDetail
    }
  }
}
    ${AdminSmsTranslationDetailFragmentDoc}
${AdminFaqTranslationDetailFragmentDoc}
${AdminContactTranslationDetailFragmentDoc}
${AdminDirectionsTranslationDetailFragmentDoc}
${AdminLinkTranslationDetailFragmentDoc}
${AdminContentTranslationDetailFragmentDoc}`;
export const PracticeTranslationsQueryResultFragmentDoc = gql`
    fragment practiceTranslationsQueryResult on Query {
  ...globalTranslations
  practice(practiceId: $practiceId) {
    ...practiceTranslations
  }
  translations(condition: {practiceId: $practiceId}) {
    nodes {
      ...translationDetail
    }
  }
}
    ${GlobalTranslationsFragmentDoc}
${PracticeTranslationsFragmentDoc}
${TranslationDetailFragmentDoc}`;
export const ProviderAppointmentCountsQueryResultFragmentDoc = gql`
    fragment providerAppointmentCountsQueryResult on Query {
  provider(providerId: $providerId) {
    ...providerAppointmentsCount
  }
}
    ${ProviderAppointmentsCountFragmentDoc}`;
export const ProviderDayAppointmentsV2QueryResultFragmentDoc = gql`
    fragment providerDayAppointmentsV2QueryResult on Query {
  appointments: providerDayAppointmentsV2(
    practiceId: $practiceId
    providerIds: $providerIds
    dateScheduled: $dateScheduled
    managerId: $managerId
  ) {
    nodes {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const ProviderDepartmentAppointmentCountsQueryResultFragmentDoc = gql`
    fragment providerDepartmentAppointmentCountsQueryResult on Query {
  recentAppointmentCountsGroupeds(condition: {practiceId: $practiceId}) {
    nodes {
      practiceId
      departmentId
      providerId
      appointmentTypeId
      status
      managerAppointmentCount
      appointmentCount
    }
  }
}
    `;
export const ProviderOverviewSetQueryResultFragmentDoc = gql`
    fragment providerOverviewSetQueryResult on Query {
  providers(
    filter: {practiceId: {equalTo: $practiceId}, providerId: {in: $providerIds}}
  ) {
    nodes {
      ...providerOverview
    }
  }
}
    ${ProviderOverviewFragmentDoc}`;
export const TranslationDetailQueryResultFragmentDoc = gql`
    fragment translationDetailQueryResult on Query {
  translation(translationId: $translationId) {
    ...translationDetail
  }
}
    ${TranslationDetailFragmentDoc}`;
export const AppointmentCheckInsSubscriptionResultFragmentDoc = gql`
    fragment appointmentCheckInsSubscriptionResult on Subscription {
  appointmentCheckedIn(providerId: $providerId) {
    appointment {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const AppointmentEstimateCreatedSubscriptionResultFragmentDoc = gql`
    fragment appointmentEstimateCreatedSubscriptionResult on Subscription {
  appointmentEstimateCreated(providerId: $providerId) {
    appointment {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const AppointmentEstimateUpdatesSubscriptionResultFragmentDoc = gql`
    fragment appointmentEstimateUpdatesSubscriptionResult on Subscription {
  appointmentEstimateUpdated(providerId: $providerId) {
    appointmentEstimate {
      ...appointmentEstimate
    }
  }
}
    ${AppointmentEstimateFragmentDoc}`;
export const AppointmentUpdatesSubscriptionResultFragmentDoc = gql`
    fragment appointmentUpdatesSubscriptionResult on Subscription {
  appointmentUpdated(providerId: $providerId) {
    appointment {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const GlobalProviderDashboardWarningNotifierSubscriptionResultFragmentDoc = gql`
    fragment globalProviderDashboardWarningNotifierSubscriptionResult on Subscription {
  globalProviderDashboardWarning {
    event
  }
}
    `;
export const PracticeProviderDashboardWarningNotifierSubscriptionResultFragmentDoc = gql`
    fragment practiceProviderDashboardWarningNotifierSubscriptionResult on Subscription {
  practiceProviderDashboardWarning {
    event
  }
}
    `;
export const ProviderAppointmentCancelledSubscriptionResultFragmentDoc = gql`
    fragment providerAppointmentCancelledSubscriptionResult on Subscription {
  appointmentCancelled(providerId: $providerId) {
    appointment {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const ProviderAppointmentCreatedSubscriptionResultFragmentDoc = gql`
    fragment providerAppointmentCreatedSubscriptionResult on Subscription {
  appointmentCreated(providerId: $providerId) {
    appointment {
      ...appointmentOverview
    }
  }
}
    ${AppointmentOverviewFragmentDoc}`;
export const ProviderAppointmentExamDelaysSubscriptionResultFragmentDoc = gql`
    fragment providerAppointmentExamDelaysSubscriptionResult on Subscription {
  appointmentExamDelays(providerId: $providerId) {
    appointment {
      ...appointmentOverview
      patient {
        ...patientOverview
      }
      provider {
        ...providerOverview
      }
    }
  }
}
    ${AppointmentOverviewFragmentDoc}
${PatientOverviewFragmentDoc}
${ProviderOverviewFragmentDoc}`;
export const ProviderAppointmentIntakeDelaysSubscriptionResultFragmentDoc = gql`
    fragment providerAppointmentIntakeDelaysSubscriptionResult on Subscription {
  appointmentIntakeDelays(providerId: $providerId) {
    appointment {
      ...appointmentOverview
      patient {
        ...patientOverview
      }
      provider {
        ...providerOverview
      }
    }
  }
}
    ${AppointmentOverviewFragmentDoc}
${PatientOverviewFragmentDoc}
${ProviderOverviewFragmentDoc}`;
export const ProviderDepartmentAppointmentCountCreatedSubscriptionResultFragmentDoc = gql`
    fragment providerDepartmentAppointmentCountCreatedSubscriptionResult on Subscription {
  providerAppointmentCountCreated(providerId: $providerId) {
    providerDepartmentAppointmentCount {
      ...providerDepartmentAppointmentCount
    }
  }
}
    ${ProviderDepartmentAppointmentCountFragmentDoc}`;
export const ProviderDepartmentAppointmentCountUpdatedSubscriptionResultFragmentDoc = gql`
    fragment providerDepartmentAppointmentCountUpdatedSubscriptionResult on Subscription {
  providerAppointmentCountUpdated(providerId: $providerId) {
    providerDepartmentAppointmentCount {
      ...providerDepartmentAppointmentCount
    }
  }
}
    ${ProviderDepartmentAppointmentCountFragmentDoc}`;
export const ReceptionStatusPracticeFragmentDoc = gql`
    fragment receptionStatusPractice on Practice {
  practiceId
  name
}
    `;
export const ReceptionStatusProviderFragmentDoc = gql`
    fragment receptionStatusProvider on Provider {
  providerId
  displayName
  displayNameCompiled
  displayNameOverride
}
    `;
export const ActorDelayConfigsFragmentDoc = gql`
    fragment actorDelayConfigs on Actor {
  actorId
  managerNotifyTimeInReceptionDelays
  managerNotifyTimeInReceptionDelaysMethod
  managerNotifyTimeInReceptionDelaysAfterMinutes
  managerIgnoreTimeInReceptionEarlyCheckIn
  managerNotifyWaitForIntakeDelays
  managerNotifyWaitForIntakeDelaysMethod
  managerNotifyWaitForIntakeDelaysAfterMinutes
  managerNotifyWaitForDoctorDelays
  managerNotifyWaitForDoctorDelaysMethod
  managerNotifyWaitForDoctorDelaysAfterMinutes
}
    `;
export const AppointmentTypePredictedDurationsFragmentDoc = gql`
    fragment appointmentTypePredictedDurations on AppointmentType {
  appointmentTypeId
  estimatedDuration
  checkInPredictedDuration
  waitForIntakePredictedDuration
  intakePredictedDuration
  waitForDoctorPredictedDuration
  waitForExamPredictedDuration: waitForDoctorPredictedDuration
  inExamPredictedDuration
  examPredictedDuration: inExamPredictedDuration
  waitForCheckoutPredictedDuration
  waitForCheckOutPredictedDuration: waitForCheckoutPredictedDuration
  checkOutPredictedDuration
}
    `;
export const AppointmentTypeTemplatesTranslationsFragmentDoc = gql`
    fragment appointmentTypeTemplatesTranslations on AppointmentType {
  templateId
}
    `;
export const AdminAppointmentTypeDetailFragmentDoc = gql`
    fragment adminAppointmentTypeDetail on AppointmentType {
  ...appointmentTypeOverview
  ...appointmentTypePredictedDurations
  ...appointmentTypeTemplatesTranslations
}
    ${AppointmentTypeOverviewFragmentDoc}
${AppointmentTypePredictedDurationsFragmentDoc}
${AppointmentTypeTemplatesTranslationsFragmentDoc}`;
export const ManagerPasswordResetTokenFragmentDoc = gql`
    fragment managerPasswordResetToken on ManagerPasswordResetToken {
  managerPasswordResetTokenId
  token
  expiresAt
  usedAt
  managerId
}
    `;
export const AdminManagerDetailFragmentDoc = gql`
    fragment adminManagerDetail on Manager {
  ...managerOverview
  eulaTimestamp
  created
  updated
  eulaTimestamp
  tableauManager {
    managerId
    username
    email
  }
  managerPasswordResetTokens {
    nodes {
      ...managerPasswordResetToken
    }
  }
  managerProviderPermissions {
    nodes {
      ...managerProviderPermission
    }
    aggregates {
      distinctCount {
        providerId
        departmentId
      }
    }
  }
}
    ${ManagerOverviewFragmentDoc}
${ManagerPasswordResetTokenFragmentDoc}
${ManagerProviderPermissionFragmentDoc}`;
export const ProviderDepartmentPaidConversionFragmentDoc = gql`
    fragment providerDepartmentPaidConversion on ProviderDepartmentPaidConversion {
  providerDepartmentPaidConversionId
  practiceId
  providerId
  departmentId
  dateTrialStart
  dateTrialEnd
  datePaidStart
  datePaidEnd
  created
  updated
}
    `;
export const AdminProviderDetailFragmentDoc = gql`
    fragment adminProviderDetail on Provider {
  ...providerDetail
  ...providerAppointmentsCount
  managerProviderPermissions {
    aggregates {
      distinctCount {
        managerId
      }
    }
  }
  providerDepartmentPaidConversions {
    nodes {
      ...providerDepartmentPaidConversion
    }
  }
}
    ${ProviderDetailFragmentDoc}
${ProviderAppointmentsCountFragmentDoc}
${ProviderDepartmentPaidConversionFragmentDoc}`;
export const AppointmentCalculationsWithNowFragmentDoc = gql`
    fragment appointmentCalculationsWithNow on AppointmentCalculationsWithNow {
  appointmentId
  checkInDurationMinutes
  waitForIntakeDurationMinutes
  intakeDurationMinutes
  waitForExamDurationMinutes
  examDurationMinutes
  waitForCheckOutDurationMinutes
  checkOutDurationMinutes
}
    `;
export const AppointmentDurationsCompiledFragmentDoc = gql`
    fragment appointmentDurationsCompiled on AppointmentDurationsCompiled {
  appointmentId
  checkInPredictedDuration
  waitForIntakePredictedDuration
  intakePredictedDuration
  waitForExamPredictedDuration
  examPredictedDuration
  waitForCheckOutPredictedDuration
  checkOutPredictedDuration
}
    `;
export const AppointmentTypeDetailFragmentDoc = gql`
    fragment appointmentTypeDetail on AppointmentType {
  ...appointmentTypeOverview
}
    ${AppointmentTypeOverviewFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment pageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const PatientAppointmentEstimateFragmentDoc = gql`
    fragment patientAppointmentEstimate on AppointmentEstimate {
  appointmentId
  suggestedArrivalTime
  estIntakeTime
}
    `;
export const PatientAppointmentFragmentDoc = gql`
    fragment patientAppointment on Appointment {
  appointmentId
  timeScheduled
  appointmentEstimate {
    ...patientAppointmentEstimate
  }
}
    ${PatientAppointmentEstimateFragmentDoc}`;
export const PatientDepartmentFragmentDoc = gql`
    fragment patientDepartment on Department {
  departmentId
  name
  publicName
  timezone
  phoneNumber
  address {
    ...address
  }
}
    ${AddressFragmentDoc}`;
export const PatientProviderFragmentDoc = gql`
    fragment patientProvider on Provider {
  providerId
}
    `;
export const PatientPracticeFragmentDoc = gql`
    fragment patientPractice on Practice {
  practiceId
  name
}
    `;
export const PatientPatientFragmentDoc = gql`
    fragment patientPatient on Patient {
  patientId
  fullNameDisplay
  firstName
  middleName
  lastName
}
    `;
export const PatientAppointmentTypeFragmentDoc = gql`
    fragment patientAppointmentType on AppointmentType {
  appointmentTypeId
  name
  nameDisplay
}
    `;
export const DetailedPatientAppointmentFragmentDoc = gql`
    fragment detailedPatientAppointment on Appointment {
  ...patientAppointment
  department {
    ...patientDepartment
  }
  provider {
    ...patientProvider
  }
  practice {
    ...patientPractice
  }
  patient {
    ...patientPatient
  }
  appointmentType {
    ...patientAppointmentType
  }
}
    ${PatientAppointmentFragmentDoc}
${PatientDepartmentFragmentDoc}
${PatientProviderFragmentDoc}
${PatientPracticeFragmentDoc}
${PatientPatientFragmentDoc}
${PatientAppointmentTypeFragmentDoc}`;
export const PatientDetailFragmentDoc = gql`
    fragment patientDetail on Patient {
  ...patientOverview
}
    ${PatientOverviewFragmentDoc}`;
export const PracticeReportInputFragmentDoc = gql`
    fragment practiceReportInput on Practice {
  chartTimePerPatient
  lunchEndHour
  lunchStartHour
  lunchEndMinute
  lunchStartMinute
  lunchGap
  regularGap
}
    `;
export const PracticeFileFragmentDoc = gql`
    fragment practiceFile on PracticeFile {
  practiceFileId
  practiceId
  title
  contentType
  fileUrl
  created
  updated
}
    `;
export const PracticeSlugFragmentDoc = gql`
    fragment practiceSlug on PracticeSlug {
  practiceSlugId
  practiceId
  practiceName
  slug
  managerDashboardUrl
  patientDashboardUrl
  receptionStatusDashboardUrl
  practiceHeaderImageFile {
    ...practiceFile
  }
}
    ${PracticeFileFragmentDoc}`;
export const PracticeDetailFragmentDoc = gql`
    fragment practiceDetail on Practice {
  ...practiceOverview
  ...practiceReportInput
  practiceHeaderImageFile {
    ...practiceFile
  }
  practiceSlugs {
    nodes {
      ...practiceSlug
    }
  }
}
    ${PracticeOverviewFragmentDoc}
${PracticeReportInputFragmentDoc}
${PracticeFileFragmentDoc}
${PracticeSlugFragmentDoc}`;
export const ProviderDepartmentOptionNoIdFragmentDoc = gql`
    fragment providerDepartmentOptionNoId on ProviderDepartmentOption {
  providerId
  practiceId
  departmentId
  appointmentTypeId
  showCheckInButtonInVwr
  showSuggestedArrivalTimeInVwr
  anchorAutoPauseToSuggestedArrivalTime
  patientSiteShowCallButton
  patientSiteShowIntakeForm
  patientSiteShowLocation
  patientSiteContactTranslationId
  patientSiteDirectionsTranslationId
  appointmentPlaceholderMessageTranslationId
  appointmentScheduledMessageTranslationId
  appointmentReminderMessageTranslationId
  appointmentDelayedMessageTranslationId
  appointmentRoomReadyMessageTranslationId
  patientSiteRemoteDirectionsTranslationId
  patientSiteFaqTranslationId
  patientSiteIntakeFormUrlTranslationId
  patientSiteGettingToLinkATranslationId
  patientSiteGettingToLinkBTranslationId
  patientSiteBeforeLinkATranslationId
  patientSiteBeforeLinkBTranslationId
  patientSiteArrivedLinkATranslationId
  patientSiteArrivedLinkBTranslationId
  patientSiteAboutLinkATranslationId
  patientSiteAboutLinkBTranslationId
  patientSiteAfterLinkATranslationId
  patientSiteAfterLinkBTranslationId
  googlePlaceId
  suggestedArrivalTimeMaxDriftMinutes
  patientSiteDisplayPaymentPortal
  patientSiteDisplayPatientPortal
  appointmentsHideOnStatus
  appointmentsHideOnManager
  appointmentsDisableDelayCalc
  patientSiteDisplayLatestSmsSuggestedArrivalTime
  patientSitePracticeSlugId
  autoPauseAfterMinutes
  forcePauseAfterMinutes
  minMinutesBetweenReminderTexts
  patientSiteAboutVideoLinkTranslationId
  useRenderingProvider
  statsType
  persistCheckInToEhr
  useStatsV2
  useMLDurations
  excludeFromViewsAndQueues
  appointmentsAutoTextingDisabled
  noSmsBeforeMinutesIntoDay
  pollPatientChartsOnWaitForIntakeVitals
  pollPatientChartsOnWaitForIntakeAllergies
  pollPatientChartsOnWaitForIntakeEncounterReasons
  pollPatientChartsOnWaitForIntakeProblems
  pollPatientChartsOnWaitForDoctorHpi
  pollPatientChartsOnWaitForDoctorOrders
  pollPatientChartsOnWaitForDoctorEncounterReasons
  pollPatientChartsOnWaitForDoctorReviewOfSystem
  pollPatientChartsOnExamDiagnosis
  canRollbackStatus
  useBetaOverbookedStackingBehavior
  useStatusInferenceByLocation
  preventSatBeforeDepartmentOpenHour
  patientSiteGettingToTextContentTranslationId
  patientSiteBeforeTextContentTranslationId
  patientSiteArrivedTextContentTranslationId
  patientSiteAboutTextContentTranslationId
  patientSiteAfterTextContentTranslationId
  patientSiteHeaderPracticeFileId
}
    `;
export const ProviderDepartmentOptionFragmentDoc = gql`
    fragment providerDepartmentOption on ProviderDepartmentOption {
  providerDepartmentOptionId
  ...providerDepartmentOptionNoId
}
    ${ProviderDepartmentOptionNoIdFragmentDoc}`;
export const SlotOverviewFragmentDoc = gql`
    fragment slotOverview on Slot {
  slotId
  practiceId
  providerId
  renderingProviderId
  departmentId
  appointmentTypeId
  timeScheduled
  duration
  isFrozen
  created
  updated
}
    `;
export const WaitlistOverviewFragmentDoc = gql`
    fragment waitlistOverview on Waitlist {
  waitlistId
  practiceId
  providerId
  departmentId
  appointmentTypeId
  patientId
  priority
  daysOfWeek
  hourFrom
  hourTo
  note
  created
  updated
}
    `;
export const ProviderDashboardWarningFragmentDoc = gql`
    fragment providerDashboardWarning on ProviderDashboardWarning {
  providerDashboardWarningId
  practiceId
  practice {
    practiceId
    name
  }
  providerId
  provider {
    providerId
    displayName
  }
  managerSiteMessage
  rssSiteMessage
  hideRssSiteDelays
  created
  updated
}
    `;
export const ProviderDashboardWarningsQueryResultFragmentDoc = gql`
    fragment providerDashboardWarningsQueryResult on Query {
  providerDashboardWarnings(
    filter: {or: [{practiceId: {equalTo: $practiceId}}, {practiceId: {isNull: true}}]}
  ) {
    nodes {
      ...providerDashboardWarning
    }
  }
}
    ${ProviderDashboardWarningFragmentDoc}`;
export const AdminUpdateAppointmentMutationDocument = gql`
    mutation AdminUpdateAppointmentMutation($appointmentId: String!, $practiceId: String!, $patch: AppointmentPatch!, $providerId: String!) {
  ...adminUpdateAppointmentMutationResult
}
    ${AdminUpdateAppointmentMutationResultFragmentDoc}`;
export const AuthInsightsMutationDocument = gql`
    mutation AuthInsightsMutation {
  ...authInsightsMutationResult
}
    ${AuthInsightsMutationResultFragmentDoc}`;
export const AuthTableauMutationDocument = gql`
    mutation AuthTableauMutation($email: String!) {
  ...authTableauMutationResult
}
    ${AuthTableauMutationResultFragmentDoc}`;
export const ChangeManagerPasswordMutationDocument = gql`
    mutation ChangeManagerPasswordMutation($input: ChangeManagerPasswordInput!) {
  ...changeManagerPasswordMutationResult
}
    ${ChangeManagerPasswordMutationResultFragmentDoc}`;
export const CreateProviderDepartmentAutoTextPausesMutationDocument = gql`
    mutation CreateProviderDepartmentAutoTextPausesMutation($practiceId: String!, $providerIds: [String]!) {
  ...createProviderDepartmentAutoTextPausesMutationResult
}
    ${CreateProviderDepartmentAutoTextPausesMutationResultFragmentDoc}`;
export const PauseAppointmentMutationDocument = gql`
    mutation PauseAppointmentMutation($appointmentId: String!, $practiceId: String!, $providerId: String!, $pausedAt: Datetime!) {
  ...pauseAppointmentMutationResult
}
    ${PauseAppointmentMutationResultFragmentDoc}`;
export const QueueAppointmentSmsMutationDocument = gql`
    mutation QueueAppointmentSmsMutation($input: QueueSendSmsInput!) {
  ...queueAppointmentSmsMutationResult
}
    ${QueueAppointmentSmsMutationResultFragmentDoc}`;
export const QueueDemoAppointmentTextMutationDocument = gql`
    mutation QueueDemoAppointmentTextMutation($input: QueueDemoAppointmentTextInput!) {
  ...queueDemoAppointmentTextMutationResult
}
    ${QueueDemoAppointmentTextMutationResultFragmentDoc}`;
export const SetAppointmentDoneMutationDocument = gql`
    mutation SetAppointmentDoneMutation($appointmentId: String!, $practiceId: String!, $timeEnd: Datetime!, $providerId: String!) {
  ...setAppointmentDoneMutationResult
}
    ${SetAppointmentDoneMutationResultFragmentDoc}`;
export const SetAppointmentReadyForCheckInMutationDocument = gql`
    mutation SetAppointmentReadyForCheckInMutation($input: QueueReadyForCheckInInput!, $appointmentId: String!, $practiceId: String!, $roomReadyButtonClickedAt: Datetime!) {
  ...setAppointmentReadyForCheckInMutationResult
}
    ${SetAppointmentReadyForCheckInMutationResultFragmentDoc}`;
export const UnpauseAppointmentMutationDocument = gql`
    mutation UnpauseAppointmentMutation($appointmentId: String!, $practiceId: String!, $providerId: String!) {
  ...unpauseAppointmentMutationResult
}
    ${UnpauseAppointmentMutationResultFragmentDoc}`;
export const UpdateActorManagerDashboardSettingsMutationDocument = gql`
    mutation UpdateActorManagerDashboardSettingsMutation($actorId: Int!, $settings: JSON!) {
  ...updateActorManagerDashboardSettingsMutationResult
}
    ${UpdateActorManagerDashboardSettingsMutationResultFragmentDoc}`;
export const UpdateCurrentActorInsightsDashboardSettingsMutationDocument = gql`
    mutation UpdateCurrentActorInsightsDashboardSettingsMutation($settings: JSON!) {
  ...updateCurrentActorInsightsDashboardSettingsMutationResult
}
    ${UpdateCurrentActorInsightsDashboardSettingsMutationResultFragmentDoc}`;
export const UpdateManagerMutationDocument = gql`
    mutation UpdateManagerMutation($managerId: String!, $patch: ManagerPatch!) {
  ...updateManagerMutationResult
}
    ${UpdateManagerMutationResultFragmentDoc}`;
export const AdminFavoritesQueryDocument = gql`
    query AdminFavoritesQuery($adminId: String!) {
  ...adminFavoritesQueryResult
}
    ${AdminFavoritesQueryResultFragmentDoc}`;
export const AllLanguagesQueryDocument = gql`
    query AllLanguagesQuery {
  ...allLanguagesQueryResult
}
    ${AllLanguagesQueryResultFragmentDoc}`;
export const AppointmentDetailQueryDocument = gql`
    query AppointmentDetailQuery($appointmentId: String!, $practiceId: String!) {
  ...appointmentDetailQueryResult
}
    ${AppointmentDetailQueryResultFragmentDoc}`;
export const AppointmentTypeOverviewSetQueryDocument = gql`
    query AppointmentTypeOverviewSetQuery($practiceId: String!, $appointmentTypeIds: [String!]!) {
  ...appointmentTypeOverviewSetQueryResult
}
    ${AppointmentTypeOverviewSetQueryResultFragmentDoc}`;
export const CurrentActorInsightsDashboardSettingsQueryDocument = gql`
    query CurrentActorInsightsDashboardSettingsQuery {
  ...currentActorInsightsDashboardSettingsQueryResult
}
    ${CurrentActorInsightsDashboardSettingsQueryResultFragmentDoc}`;
export const DepartmentDetailQueryDocument = gql`
    query DepartmentDetailQuery($departmentId: String!) {
  ...departmentDetailQueryResult
}
    ${DepartmentDetailQueryResultFragmentDoc}`;
export const DepartmentOverviewSetQueryDocument = gql`
    query DepartmentOverviewSetQuery($practiceId: String!, $departmentIds: [String!]!) {
  ...departmentOverviewSetQueryResult
}
    ${DepartmentOverviewSetQueryResultFragmentDoc}`;
export const EnabledLanguagesQueryDocument = gql`
    query EnabledLanguagesQuery {
  ...enabledLanguagesQueryResult
}
    ${EnabledLanguagesQueryResultFragmentDoc}`;
export const GlobalTemplatesQueryDocument = gql`
    query GlobalTemplatesQuery {
  ...globalTemplatesQueryResult
}
    ${GlobalTemplatesQueryResultFragmentDoc}`;
export const GlobalTranslationsQueryDocument = gql`
    query GlobalTranslationsQuery {
  ...globalTranslationsQueryResult
}
    ${GlobalTranslationsQueryResultFragmentDoc}`;
export const ManagerAdminBaseQueryDocument = gql`
    query ManagerAdminBaseQuery($adminId: String!) {
  ...managerAdminBaseQueryResult
}
    ${ManagerAdminBaseQueryResultFragmentDoc}`;
export const ManagerAppointmentDayQueryDocument = gql`
    query ManagerAppointmentDayQuery($practiceId: String!, $providerIds: [String!]!, $dayStart: Datetime!, $dayEnd: Datetime!, $filterStatuses: [String!]!, $managerId: String) {
  ...managerAppointmentDayQueryResult
}
    ${ManagerAppointmentDayQueryResultFragmentDoc}`;
export const ManagerBaseQueryDocument = gql`
    query ManagerBaseQuery {
  ...managerBaseQueryResult
}
    ${ManagerBaseQueryResultFragmentDoc}`;
export const ManagerBillingInfoQueryDocument = gql`
    query ManagerBillingInfoQuery($practiceId: String!) {
  ...managerBillingInfoQueryResult
}
    ${ManagerBillingInfoQueryResultFragmentDoc}`;
export const ManagerCancelledAppointmentDayQueryDocument = gql`
    query ManagerCancelledAppointmentDayQuery($practiceId: String!, $providerIds: [String!]!, $dayStart: Datetime!, $dayEnd: Datetime!, $managerId: String) {
  ...managerCancelledAppointmentDayQueryResult
}
    ${ManagerCancelledAppointmentDayQueryResultFragmentDoc}`;
export const ManagerCancelledAppointmentDayV2QueryDocument = gql`
    query ManagerCancelledAppointmentDayV2Query($practiceId: String!, $providerIds: [String!]!, $dateStart: Date!, $dateEnd: Date!, $canceledWithinHours: Float!, $managerId: String) {
  ...managerCancelledAppointmentDayV2QueryResult
}
    ${ManagerCancelledAppointmentDayV2QueryResultFragmentDoc}`;
export const ManagerCancelledAppointmentDayV3QueryDocument = gql`
    query ManagerCancelledAppointmentDayV3Query($practiceId: String!, $providerIds: [String!]!, $dateStart: Date!, $dateEnd: Date!, $canceledWithinHours: Float!, $managerId: String, $dateScheduled: String) {
  ...managerCancelledAppointmentDayV3QueryResult
}
    ${ManagerCancelledAppointmentDayV3QueryResultFragmentDoc}`;
export const ManagerManagersHistoryQueryDocument = gql`
    query ManagerManagersHistoryQuery($managerId: String!) {
  ...managerManagersHistoryQueryResult
}
    ${ManagerManagersHistoryQueryResultFragmentDoc}`;
export const ManagerOverviewQueryDocument = gql`
    query ManagerOverviewQuery($managerId: String!) {
  ...managerOverviewQueryResult
}
    ${ManagerOverviewQueryResultFragmentDoc}`;
export const ManagerPracticeBaseQueryDocument = gql`
    query ManagerPracticeBaseQuery($practiceId: String!, $dayStart: Date!) {
  ...managerPracticeBaseQueryResult
}
    ${ManagerPracticeBaseQueryResultFragmentDoc}`;
export const ManagerPracticeManagersQueryDocument = gql`
    query ManagerPracticeManagersQuery($practiceId: String!) {
  ...managerPracticeManagersQueryResult
}
    ${ManagerPracticeManagersQueryResultFragmentDoc}`;
export const ManagerPracticeProviderCountsQueryDocument = gql`
    query ManagerPracticeProviderCountsQuery($practiceId: String!, $providerIds: [String!]!, $dayStart: Date!) {
  ...managerPracticeProviderCountsQueryResult
}
    ${ManagerPracticeProviderCountsQueryResultFragmentDoc}`;
export const ManagerProvidersHistoryQueryDocument = gql`
    query ManagerProvidersHistoryQuery($providerId: String!) {
  ...managerProvidersHistoryQueryResult
}
    ${ManagerProvidersHistoryQueryResultFragmentDoc}`;
export const PracticeAppointmentCycleConfigsQueryDocument = gql`
    query PracticeAppointmentCycleConfigsQuery($practiceId: String!) {
  ...practiceAppointmentCycleConfigsQueryResult
}
    ${PracticeAppointmentCycleConfigsQueryResultFragmentDoc}`;
export const PracticeAppointmentCycleDefaultValuesQueryDocument = gql`
    query PracticeAppointmentCycleDefaultValuesQuery($practiceId: String!) {
  ...practiceAppointmentCycleDefaultValuesQueryResult
}
    ${PracticeAppointmentCycleDefaultValuesQueryResultFragmentDoc}`;
export const PracticeOverviewQueryDocument = gql`
    query PracticeOverviewQuery($practiceId: String!) {
  ...practiceOverviewQueryResult
}
    ${PracticeOverviewQueryResultFragmentDoc}`;
export const PracticeProviderAutoTextPausesQueryDocument = gql`
    query practiceProviderAutoTextPausesQuery($practiceId: String!, $pauseOnDate: Date!) {
  ...practiceProviderAutoTextPausesQueryResult
}
    ${PracticeProviderAutoTextPausesQueryResultFragmentDoc}`;
export const PracticeReportsQueryDocument = gql`
    query PracticeReportsQuery($practiceId: String!) {
  practice(practiceId: $practiceId) {
    practiceId
    practiceTableauReports {
      totalCount
      nodes {
        ...practiceTableauReport
      }
    }
  }
}
    ${PracticeTableauReportFragmentDoc}`;
export const PracticeTemplatesQueryDocument = gql`
    query PracticeTemplatesQuery($practiceId: String!) {
  ...practiceTemplatesQueryResult
}
    ${PracticeTemplatesQueryResultFragmentDoc}`;
export const PracticeTranslationsQueryDocument = gql`
    query PracticeTranslationsQuery($practiceId: String!) {
  ...practiceTranslationsQueryResult
}
    ${PracticeTranslationsQueryResultFragmentDoc}`;
export const ProviderAppointmentCountsQueryDocument = gql`
    query ProviderAppointmentCountsQuery($providerId: String!, $dayStart: Date!) {
  ...providerAppointmentCountsQueryResult
}
    ${ProviderAppointmentCountsQueryResultFragmentDoc}`;
export const ProviderDayAppointmentsV2QueryDocument = gql`
    query ProviderDayAppointmentsV2Query($practiceId: String!, $providerIds: [String!]!, $dateScheduled: String!, $managerId: String) {
  ...providerDayAppointmentsV2QueryResult
}
    ${ProviderDayAppointmentsV2QueryResultFragmentDoc}`;
export const ProviderDepartmentAppointmentCountsQueryDocument = gql`
    query ProviderDepartmentAppointmentCountsQuery($practiceId: String!) {
  ...providerDepartmentAppointmentCountsQueryResult
}
    ${ProviderDepartmentAppointmentCountsQueryResultFragmentDoc}`;
export const ProviderOverviewSetQueryDocument = gql`
    query ProviderOverviewSetQuery($practiceId: String!, $providerIds: [String!]!) {
  ...providerOverviewSetQueryResult
}
    ${ProviderOverviewSetQueryResultFragmentDoc}`;
export const TranslationDetailQueryDocument = gql`
    query TranslationDetailQuery($translationId: String!) {
  ...translationDetailQueryResult
}
    ${TranslationDetailQueryResultFragmentDoc}`;
export const AppointmentCheckInsSubscriptionDocument = gql`
    subscription AppointmentCheckInsSubscription($providerId: String!) {
  ...appointmentCheckInsSubscriptionResult
}
    ${AppointmentCheckInsSubscriptionResultFragmentDoc}`;
export const AppointmentEstimateCreatedSubscriptionDocument = gql`
    subscription AppointmentEstimateCreatedSubscription($providerId: String!) {
  ...appointmentEstimateCreatedSubscriptionResult
}
    ${AppointmentEstimateCreatedSubscriptionResultFragmentDoc}`;
export const AppointmentEstimateUpdatesSubscriptionDocument = gql`
    subscription AppointmentEstimateUpdatesSubscription($providerId: String!) {
  ...appointmentEstimateUpdatesSubscriptionResult
}
    ${AppointmentEstimateUpdatesSubscriptionResultFragmentDoc}`;
export const AppointmentUpdatesSubscriptionDocument = gql`
    subscription AppointmentUpdatesSubscription($providerId: String!) {
  ...appointmentUpdatesSubscriptionResult
}
    ${AppointmentUpdatesSubscriptionResultFragmentDoc}`;
export const GlobalProviderDashboardWarningNotifierSubscriptionDocument = gql`
    subscription GlobalProviderDashboardWarningNotifierSubscription {
  ...globalProviderDashboardWarningNotifierSubscriptionResult
}
    ${GlobalProviderDashboardWarningNotifierSubscriptionResultFragmentDoc}`;
export const PracticeProviderDashboardWarningNotifierSubscriptionDocument = gql`
    subscription PracticeProviderDashboardWarningNotifierSubscription {
  ...practiceProviderDashboardWarningNotifierSubscriptionResult
}
    ${PracticeProviderDashboardWarningNotifierSubscriptionResultFragmentDoc}`;
export const ProviderAppointmentCancelledSubscriptionDocument = gql`
    subscription ProviderAppointmentCancelledSubscription($providerId: String!) {
  ...providerAppointmentCancelledSubscriptionResult
}
    ${ProviderAppointmentCancelledSubscriptionResultFragmentDoc}`;
export const ProviderAppointmentCreatedSubscriptionDocument = gql`
    subscription ProviderAppointmentCreatedSubscription($providerId: String!) {
  ...providerAppointmentCreatedSubscriptionResult
}
    ${ProviderAppointmentCreatedSubscriptionResultFragmentDoc}`;
export const ProviderAppointmentExamDelaysSubscriptionDocument = gql`
    subscription ProviderAppointmentExamDelaysSubscription($providerId: String!) {
  ...providerAppointmentExamDelaysSubscriptionResult
}
    ${ProviderAppointmentExamDelaysSubscriptionResultFragmentDoc}`;
export const ProviderAppointmentIntakeDelaysSubscriptionDocument = gql`
    subscription ProviderAppointmentIntakeDelaysSubscription($providerId: String!) {
  ...providerAppointmentIntakeDelaysSubscriptionResult
}
    ${ProviderAppointmentIntakeDelaysSubscriptionResultFragmentDoc}`;
export const ProviderDepartmentAppointmentCountCreatedSubscriptionDocument = gql`
    subscription ProviderDepartmentAppointmentCountCreatedSubscription($providerId: String!) {
  ...providerDepartmentAppointmentCountCreatedSubscriptionResult
}
    ${ProviderDepartmentAppointmentCountCreatedSubscriptionResultFragmentDoc}`;
export const ProviderDepartmentAppointmentCountUpdatedSubscriptionDocument = gql`
    subscription ProviderDepartmentAppointmentCountUpdatedSubscription($providerId: String!) {
  ...providerDepartmentAppointmentCountUpdatedSubscriptionResult
}
    ${ProviderDepartmentAppointmentCountUpdatedSubscriptionResultFragmentDoc}`;
export const ProviderDashboardWarningsQueryDocument = gql`
    query ProviderDashboardWarningsQuery($practiceId: String!) {
  ...providerDashboardWarningsQueryResult
}
    ${ProviderDashboardWarningsQueryResultFragmentDoc}`;